import React, { useEffect, useMemo, useRef, useState } from "react";
import i18n from "i18next";

// Fluent UI Imports
import { Text, Button } from "@fluentui/react-components";

// STL Viewer
import STLViewer from "stl-viewer";

import useWindowSize from "../helpers/useWindowSize";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { DismissRegular } from "@fluentui/react-icons";

interface IDocumentPdfViewer01Props {
  onDismiss: any;
  title: string;
  path: string;
  stueliId?: string | undefined;
  addToBedarf?: any;
}

function DocumentPdfViewer01(props: IDocumentPdfViewer01Props) {
  const [numPages, setNumPages] = useState(0);
  const size = useWindowSize();
  const pageRefs = useRef(new Array());

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: "relative",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            width: "80%",
          }}
        >
          <div style={{ minHeight: 30, marginBottom: 10 }}>
            <StackShim
              horizontal
              verticalAlign="center"
              horizontalAlign={"end"}
            >
              <Text>{props.title}</Text>
              <Button
                appearance="transparent"
                icon={<DismissRegular />}
                title={i18n.t<string>("close")}
                onClick={() => {
                  props.onDismiss();
                }}
              />
            </StackShim>
            <div
              style={{
                height: props.path.toLowerCase().endsWith(".pdf")
                  ? "88vh"
                  : "auto",
                background: "#f2f2f2",
                position: "relative",
                overflow: "hidden",
                flex: "4 4 auto",
              }}
            >
              <STLViewer
                width={size.width / 1.28}
                height={size.height / 1.5}
                model={props.path}
                modelColor="#B92C2C"
                rotate={false}
                orbitControls={true}
                lights={[
                  [0.5, 0.5, 0.5],
                  [-0.5, -0.5, -0.5],
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DocumentPdfViewer01;
